import { KalturaTranslationToken } from '@kaltura-ott/ott-client-types/api/types';

export const stringToTranslationToken = (value: string, language = 'eng'): KalturaTranslationToken => {
  return new KalturaTranslationToken({ language, value });
};
